<template>
  <div class="mb-4">
    <h6 class="fw-bold mb-3">
      {{ activityName }}
    </h6>
    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Numéro ORIAS</label>
        <input
          v-model="oriasNumber"
          type="text"
          class="form-control"
          :class="touchedField ? `is-${isOriasNumberValid ? 'valid' : 'invalid'}` : ''"
          placeholder="Entrez le numéro ORIAS"
          @blur="touchedField = true"
        >
        <div
          v-if="touchedField && !isOriasNumberValid"
          class="invalid-feedback"
        >
          Le numéro ORIAS doit contenir 8 chiffres maximum
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';

export default {
  name: 'ComplementaryOriasForm',
  props: {
    contract: {
      type: Object,
      required: true,
    },
    activityName: {
      type: String,
      default: 'Activité',
    },
  },
  emits: ['validation'],
  data() {
    return {
      oriasNumber: '',
      touchedField: false,
    };
  },
  computed: {
    isOriasNumberValid() {
      if (this.oriasNumber.length === 0) return false;
      const cleanValue = this.oriasNumber.replace(/\s/g, '');
      return /^\d{1,8}$/.test(cleanValue);
    },
    hasError() {
      return !this.isOriasNumberValid;
    },
  },
  watch: {
    hasError: {
      immediate: true,
      handler(val) {
        this.$emit('validation', !val);
      },
    },
  },
  mounted() {
    this.oriasNumber = get(this.contract, 'risk.oriasNumber', '');
  },
  methods: {
    async submit() {
      return { oriasNumber: this.oriasNumber };
    },
  },
};
</script>
